export default "__VITE_ASSET__BujPgnLQ__"